<mat-toolbar class="mat-elevation-z8">
  {{ 'PRICING.ADDITIONAL_SERVICES.ADD_ADDITIONAL_SERVICES' | transloco }}
</mat-toolbar>

<!-- <div *ngIf="isLoading" class="spinner">
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div> -->

<mat-dialog-content>
  <div class="container">
    <form [formGroup]="servicesForm">
      @if (remainingServices && remainingServices.length > 0) {
        <div>
          <h4 class="mb-2">Available Services</h4>
          <div formArrayName="selectedServices" class="mb-3 border">
            <mat-selection-list>
              @for (service of remainingServices; track service) {
                <mat-list-option [value]="service"
                  (click)="onCheckboxChange($event, service)">
                  <div class="d-flex justify-content-between w-100">
                    <span>{{service.name | translateAttribute}}</span>
                    <span>{{service.totalPrice | currency:'SEK ':'symbol':'1.2-2'}}</span>
                  </div>
                </mat-list-option>
              }
            </mat-selection-list>
          </div>
          <h4 class="mt-2 mb-2">Selected Services</h4>
          <div class="p-2 border">
            @for (service of orderAdditionalServices; track service) {
              <div class="p-2">
                <div class="service-item">
                  <div class="service-name">{{ service.name | translateAttribute }}</div>
                  <div class="service-price">
                    {{ service.totalPrice | currency:'SEK ':'symbol':'1.2-2' }}
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="mt-3">
            <h4 class="mb-2">Payment required?</h4>
            <mat-radio-group formControlName="paymentRequired" aria-label="Payment required">
              <mat-radio-button class="me-3" value="yes">Yes</mat-radio-button>
              <mat-radio-button value="no">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      } @else {
        <p>No additional services available to add.</p>
      }
    </form>
  </div>

</mat-dialog-content>

<mat-dialog-actions class="pe-4 py-3" align="end">
  <button mat-button (click)="cancelDialog()">{{ 'PRICING.FORM.CANCEL' | transloco }}</button>
  <button mat-raised-button color="primary" (click)="submitSelectedServices()">{{
  'PRICING.ADDITIONAL_SERVICES.ADD_SELECTED_SERVICES' | transloco }}</button>
</mat-dialog-actions>